import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './SideBar.scss';

import commonConstant from '../../../common/_commonConstant';
import { Loading } from '../../../components';
import { isSuperAdmin, isAccounting, passParamsToPath, history, isOperation, isAdmin } from '../../../helpers';

class SideBar extends Component {
  handlePathAccountingReport = () => {
    const { getProfile } = this.props;

    if (isSuperAdmin(getProfile)) {
      return history.push(commonConstant.pathSelectBuilding);
    } else if (isAccounting(getProfile)) {
      return history.push(passParamsToPath(commonConstant.pathAccountingReport, getProfile.building));
    }
    return null;
  }

  render() {
    const { 'match': { path, params }, getProfile/*, match */, currentBuildingDataPath } = this.props;

    if (!getProfile) {
      return <Loading />;
    } else if (isOperation(getProfile)) {
      return (
        <div className="SideBar">
          <NavLink id="operation-report-page" to={passParamsToPath(commonConstant.pathOperationReport, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-report" />
              <div className="menu-title">Operation Report</div>
            </div>
            <div className="line" />
          </NavLink>
          <NavLink id="export-operation-report-page" to={passParamsToPath(commonConstant.pathExportOperationReport, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-export" />
              <div className="menu-title">Export report</div>
            </div>
            <div className="line" />
          </NavLink>
          <NavLink id="operation-dashboard-page" to={passParamsToPath(commonConstant.pathOperationDashboard, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon fas fa-chart-line" />
              <div className="menu-title">Dashboard</div>
            </div>
            <div className="line" />
          </NavLink>
        </div>
      );
    } else if (isAdmin(getProfile)) {
      return (
        <div className="SideBar">
          <NavLink id="operation-report-page" to={passParamsToPath(commonConstant.pathUserManagement, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-report" />
              <div className="menu-title">User Management</div>
            </div>
            <div className="line" />
          </NavLink>
          <NavLink id="export-operation-report-page" to={passParamsToPath(commonConstant.pathManageMembership, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-member" />
              <div className="menu-title">Manage Membership</div>
            </div>
            <div className="line" />
          </NavLink>
          <NavLink id="parking-day-config-page" to={passParamsToPath(commonConstant.pathParkingDayConfig, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-calendar-1" />
              <div className="menu-title">Parking day config</div>
            </div>
            <div className="line" />
          </NavLink>
          <NavLink id="custom-day-config-page" to={passParamsToPath(commonConstant.pathCustomDayConfig, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-calendar-2" />
              <div className="menu-title">Custom day config</div>
            </div>
            <div className="line" />
          </NavLink>
        </div>
      );
    } else if (isSuperAdmin(getProfile)) {      
      if (path !== commonConstant.pathSelectBuilding && path !== commonConstant.pathCreateBuilding && path !== commonConstant.pathEditDraftedBuilding && (currentBuildingDataPath || params)) {        
        return (
          <div className="SideBar">
            <NavLink id="select-building-page" to={passParamsToPath(commonConstant.pathSelectBuilding, (currentBuildingDataPath ? currentBuildingDataPath : params))} className="box-menu-item" activeClassName="active">
              <div className="group-detail">
                <div className="icon icon-home" />
                <div className="menu-title">Home</div>
              </div>
              <div className="line" />
            </NavLink>
            <NavLink id="acconting-report-page" to={passParamsToPath(commonConstant.pathAccountingReport, (currentBuildingDataPath ? currentBuildingDataPath : params))} className="box-menu-item" activeClassName="active">
              <div className="group-detail">
                <div className="icon icon-accounting-report" />
                <div className="menu-title">Accounting report</div>
              </div>
              <div className="line" />
            </NavLink>
            <NavLink id="tenant-management-page" to={passParamsToPath(commonConstant.pathTenantManagement, (currentBuildingDataPath ? currentBuildingDataPath : params))} className="box-menu-item" activeClassName="active">
              <div className="group-detail">
                <div className="icon icon-tenant-management" />
                <div className="menu-title">Tenant management</div>
              </div>
            </NavLink>
            <NavLink id="parking-day-config-page" to={passParamsToPath(commonConstant.pathParkingDayConfig, (currentBuildingDataPath ? currentBuildingDataPath : params))} className="box-menu-item" activeClassName="active">
              <div className="group-detail">
                <div className="icon icon-calendar-1" />
                <div className="menu-title">Parking day config</div>
              </div>
              <div className="line" />
            </NavLink>
            <NavLink id="custom-day-config-page" to={passParamsToPath(commonConstant.pathCustomDayConfig, (currentBuildingDataPath ? currentBuildingDataPath : params))} className="box-menu-item" activeClassName="active">
              <div className="group-detail">
                <div className="icon icon-calendar-2" />
                <div className="menu-title">Custom day config</div>
              </div>
              <div className="line" />
            </NavLink>
            <NavLink id="onboard-form-page" to={passParamsToPath(commonConstant.pathOnboardForm, (currentBuildingDataPath ? currentBuildingDataPath : params))} className="box-menu-item" activeClassName="active">
              <div className="group-detail">
                <div className="icon icon-building" />
                <div className="menu-title">Onboard form</div>
              </div>
              <div className="line" />
            </NavLink>
          </div>
        );
      }

      return (
        <div className="SideBar">
          <NavLink id="select-building-page" to={passParamsToPath(commonConstant.pathSelectBuilding, getProfile.building)} className="box-menu-item" activeClassName="active">
            <div className="group-detail">
              <div className="icon icon-home" />
              <div className="menu-title">Home</div>
            </div>
            <div className="line" />
          </NavLink>
        </div>
      );
    }

    return null;
    // TODO: feature parking management is done delete this comment
    // return (
    //   <div className="SideBar">
    //     <div
    //       className={`box-menu-item${match.path === commonConstant.pathSelectBuilding || match.path === commonConstant.pathAccountingReport ? ' active' : ''}`}
    //       onClick={this.handlePathAccountingReport}
    //     >
    //       <div className="group-detail">
    //         <div className="icon icon-report" />
    //         <div className="menu-title">Accounting Report</div>
    //       </div>
    //       <div className="line" />
    //     </div>
    //     {/* TODO: path parking management */}
    //     <NavLink to="" className="box-menu-item" activeClassName="active">
    //       <div className="group-detail">
    //         <div className="icon icon-parking-management" />
    //         <div className="menu-title">Parking management</div>
    //       </div>
    //       <div className="line" />
    //     </NavLink>
    //   </div>
    // );
  }
}

SideBar.propTypes = {
  'match': PropTypes.shape({
    'path': PropTypes.string,
  }),
  'getProfile': PropTypes.shape({
    'building': PropTypes.shape({}),
  }),
  'currentBuildingDataPath' : PropTypes.shape({}),
};

const mapStateToProps = ({ getProfile, getBuildingByRefNo, currentBuildingDataPath }) => ({ 'getProfile': getProfile.data, 'getBuildingByRefNo': getBuildingByRefNo.data, 'currentBuildingDataPath': currentBuildingDataPath.data });

export default connect(mapStateToProps)(withRouter(SideBar));
